import React from "react";
import { Link } from "react-router-dom";
import { IsEmpty } from "../../../util/commonFunctions";

const DeleteAccount = props => {
  return (
    <React.Fragment>
      <div className="text-center mt50">
        {!IsEmpty(props.errorMessage) ? (
          <h3>Your account can't be deleted.</h3>
        ) : (
          <h3>Your account has been deleted.</h3>
        )}
      </div>

      <div className="text-center mar-popup-image">
        {!IsEmpty(props.errorMessage) && (
          <p className="error">{props.errorMessage}</p>
        )}
        {IsEmpty(props.errorMessage) && (
          <img src="/assets/svg/confirmSuccess.svg" alt="confirmed" />
        )}
      </div>
      <div className="text-center">
        {IsEmpty(props.errorMessage) && (
          <p className="mb20 subheading opacity">
            <span>
              We’re sorry to see you go. If you would like to tell us why you
              chose to delete your account, contact us at
            </span>
            <a href="mailto:support@ausbiz.com.au">&nbsp;support@ausbiz.com.au</a>
          </p>
        )}
      </div>
      <div className="text-center mt75">
        <Link to="/" className="btn continue active">
          Done
        </Link>
      </div>
    </React.Fragment>
  );
};

export default DeleteAccount;
